import { render, staticRenderFns } from "./SelectorCustomerIdentification.vue?vue&type=template&id=e36484d8&"
import script from "./SelectorCustomerIdentification.vue?vue&type=script&lang=js&"
export * from "./SelectorCustomerIdentification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports